import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  selectCurrentThreadId,
  selectThreadMessageIds,
  setThreadId,
  useAppDispatch,
  useAppSelector,
  useGetThreadMessagesQuery,
  useGetThreadQuery,
} from '@fly/store';

export const useThreadResolver = () => {
  const dispatch = useAppDispatch();
  const currentThreadId = useSelector(selectCurrentThreadId);

  const {
    data: fetchedThread = null,
    isLoading: isThreadQueryLoading,
    isError: isThreadError,
  } = useGetThreadQuery(currentThreadId!, {
    skip: !currentThreadId,
  });

  const currentThread =
    currentThreadId && fetchedThread?.thread_id === currentThreadId
      ? fetchedThread
      : null;

  const messageIds = useAppSelector((state) =>
    selectThreadMessageIds(state, currentThread?.thread_id || '')
  );

  const {
    data: threadMessages = [],
    isLoading: isMessagesLoading,
    isFetching: isMessagesFetching,
    isError: isThreadMessagesError,
  } = useGetThreadMessagesQuery(currentThreadId!, {
    skip: !currentThreadId,
  });

  const isThreadLoading =
    !!currentThreadId &&
    (isThreadQueryLoading || isMessagesLoading || isMessagesFetching);

  const isThreadEmpty =
    !currentThreadId || (threadMessages.length === 0 && !isThreadLoading);

  useEffect(() => {
    if (isThreadError || isThreadMessagesError) {
      dispatch(setThreadId(null));
    }
  }, [isThreadError, isThreadMessagesError, dispatch]);

  return {
    currentThread,
    currentThreadId,
    messageIds,
    isThreadLoading,
    isThreadEmpty,
  };
};
